<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>
      <v-card width="100%" max-width="400" outlined>
        <v-card-title>
          {{ $t('auth.welcome') }}
        </v-card-title>
        <v-card-text v-if="isProvider">
          <v-form v-model="isValid">
            <v-container>
              <v-layout wrap>
                <v-flex md12>
                  {{ $t('auth.labels.createProvider') }}
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="form.name"
                    :rules="rules.name"
                    :label="$t('auth.newProvider')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <div>
                    <v-checkbox color="primary" v-model="form.acceptedTOS">
                      <template v-slot:label>
                        <div>
                          <span>
                            Aceptar
                          </span>
                          <a @click.stop class="primary--text" href="https://docs.google.com/document/d/1Te9qJSArXl5YExlTpDzEl_sipAAZXC1DSyc5fJ8uP-I/edit" target="_blank">términos y condiciones</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </div>
                </v-flex>
                <v-flex md12>
                  <v-btn color="success" :disabled="!isValid || !form.acceptedTOS" @click="createProvider">
                    {{$t('auth.createProvider')}}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-text v-else>
          <v-form v-model="isValid">
            <v-container>
              <v-layout wrap>
                <v-flex md12>
                  {{ $t('auth.labels.createRestaurant') }}
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    v-model="form.name"
                    :rules="rules.name"
                    :label="$t('auth.newRestaurant')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <v-autocomplete
                    v-model="form.country"
                    label="País"
                    placeholder="MX"
                    :items="countrycodes"
                    :filter="searchCode"
                    item-text="name"
                    item-value="code"
                    dense
                    rounded
                    hide-details
                    outlined
                    :rules="rules.country"/>
                </v-flex>
                <v-flex md12>
                  <div>
                    <v-checkbox color="primary" v-model="form.acceptedTOS">
                      <template v-slot:label>
                        <div>
                          <span>
                            Aceptar
                          </span>
                          <a @click.stop class="primary--text" href="https://docs.google.com/document/d/1Te9qJSArXl5YExlTpDzEl_sipAAZXC1DSyc5fJ8uP-I/edit" target="_blank">términos y condiciones</a>
                        </div>
                      </template>
                    </v-checkbox>
                  </div>
                </v-flex>
                <v-flex md12>
                  <v-btn color="success" :disabled="!isValid || !form.acceptedTOS" @click="createRestaurant">
                    {{ $t('auth.createRestaurant') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-layout>
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import countrycodes from '@/lib/countrycodes'

export default {
  data () {
    return {
      overlay: false,
      isValid: false,
      countrycodes,
      form: {
        name: '',
        acceptedTOS: false
      },
      rules: {
        name: [
          v => !!v || this.$t('validations.name'),
          v => /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]*$/.test(v) || this.$t('validations.alphaNumericAcentuated')
        ],
        country: [v => !!v || 'Country is required']
      }
    }
  },
  computed: {
    isProvider () {
      return this.$store.state.userProvider
    }
  },
  methods: {
    async createRestaurant () {
      this.overlay = true
      try {
        await this.$api.post('/v1/restaurants', this.form)
        this.$toasted.success('Your restaurant has been created', {
          duration: 3000
        })
        await this.$store.dispatch('login/loadLoginData')
        this.$router.push({ name: 'SelectRestaurant' })
      } catch (e) {
        this.$toasted.error(e.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async createProvider () {
      this.overlay = true
      try {
        await this.$api.post('/v1/providers', this.form)
        this.$toasted.success('Your provider has been created', {
          duration: 3000
        })
        await this.$store.dispatch('login/loadLoginData')
        this.$router.push({ name: 'SelectProvider' })
      } catch (e) {
        this.$toasted.error(e.message, { duration: 3000 })
      }
      this.overlay = false
    },
    searchCode (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    }
  }
}
</script>
